import { Link } from "@tanstack/react-router";
import { Icon, type IconName } from "@snowiespace/ui/web";
import { ui } from "./styles.js";

function Item({ icon, label }: { icon: IconName; label: string }) {
  return <><Icon name={icon} /><span>{label}</span></>;
}

export function SettingsNavigation({ spaceId }: { spaceId: string }) {
  const className = ui("settings-tab");
  const activeClassName = ui("settings-tab", "settings-tab--active");
  return <nav className={ui("settings-navigation")} aria-label="Settings sections" data-scroll-owner="settings-navigation">
    <Link activeOptions={{ exact: true }} activeProps={{ className: activeClassName }} className={className} inactiveProps={{ className }} params={{ spaceId }} to="/spaces/$spaceId/settings"><Item icon="settings" label="General" /></Link>
    <Link activeProps={{ className: activeClassName }} className={className} inactiveProps={{ className }} params={{ spaceId }} to="/spaces/$spaceId/settings/snowie"><Item icon="snowie" label="Snowie" /></Link>
    <Link activeProps={{ className: activeClassName }} className={className} inactiveProps={{ className }} params={{ spaceId }} to="/spaces/$spaceId/people"><Item icon="people" label="People & agents" /></Link>
    <Link activeProps={{ className: activeClassName }} className={className} inactiveProps={{ className }} params={{ spaceId }} to="/spaces/$spaceId/rescue"><Item icon="rescue" label="Backup & Rescue" /></Link>
  </nav>;
}
